import type { ModalState, PaymentCallbacks } from './types';

const initialState: ModalState = {
  isOpen: false,
  url: null,
  callbacks: {},
};

let state: ModalState = { ...initialState };

export function getState(): ModalState {
  return state;
}

export function setState(newState: Partial<ModalState>): void {
  state = { ...state, ...newState };
}

export function resetState(): void {
  state = { ...initialState, isOpen: false, callbacks: state.callbacks };
}

export function isOpen(): boolean {
  return state.isOpen;
}

export function getCallbacks(): PaymentCallbacks {
  return state.callbacks;
}

export function setCallbacks(callbacks: PaymentCallbacks): void {
  state.callbacks = callbacks;
}
